import { render, staticRenderFns } from "./FinalRevision.vue?vue&type=template&id=78c8a523&scoped=true"
import script from "./FinalRevision.vue?vue&type=script&lang=js"
export * from "./FinalRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c8a523",
  null
  
)

export default component.exports